import { css } from '@emotion/react';

export default css({
  '.revision-card': {
    '&__header': {
      marginBottom: '0.5rem',
      marginLeft: '1.7rem',
      marginRight: '.5rem',
    },
    '&__body': {
      marginLeft: '1.5rem',
      marginRight: '1.5rem',
      wordBreak: 'break-all',
    },
  },
});
